<template>
  <v-dialog
    v-model="mudarDeTicket"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-title> Tem certeza que deseja sair sem salvar? </v-card-title>

      <v-card-actions class="justify-end">
        <v-btn
          outlined
          color="secondary"
          @click="cancelar"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="success"
          @click="salvarAlteracoes"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    mudarDeTicket: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['update:mudar-de-ticket', 'sair-e-selecionar-ticket'],

  setup(_, { emit }) {
    function emitNaoMudarDeTicket() {
      emit('update:mudar-de-ticket', false)
    }
    function emitSairESelecionarTicket() {
      emit('sair-e-selecionar-ticket')
    }
    function cancelar() {
      emitNaoMudarDeTicket()
    }
    function salvarAlteracoes() {
      emitNaoMudarDeTicket()
      emitSairESelecionarTicket()
    }

    return {
      cancelar,
      salvarAlteracoes,
    }
  },
}
</script>
